/* import __COLOCATED_TEMPLATE__ from './pause-workflows-warning.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type AiAgentSetupService from 'embercom/services/ai-agent-setup-service';

export default class PauseWorkflowsWarning extends Component {
  @service declare aiAgentSetupService: AiAgentSetupService;

  get totalWorkflowsCount() {
    return this.aiAgentSetupService.totalLiveWorkflowsCount;
  }

  get finWorkflowsCount() {
    return this.aiAgentSetupService.finStats.workflowsCount.liveFinWorkflowsCount;
  }

  get hasFinWorkflows() {
    return this.finWorkflowsCount > 0;
  }

  get translationKey() {
    if (!this.hasFinWorkflows) {
      return 'signup.teams.pricing5.annual-plans.configure-plan.features.pause-workflows.with-non-fin-workflows';
    }

    if (this.finWorkflowsCount === 1) {
      return 'signup.teams.pricing5.annual-plans.configure-plan.features.pause-workflows.with-single-fin-workflow';
    } else {
      return 'signup.teams.pricing5.annual-plans.configure-plan.features.pause-workflows.with-multiple-fin-workflows';
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Signup::Teams::Pricing5::Components::PauseWorkflowsWarning': typeof PauseWorkflowsWarning;
    'signup/teams/pricing5/components/pause-workflows-warning': typeof PauseWorkflowsWarning;
  }
}
